/**
 * ZEN ERP — pdf.js worker yönetimi (yazdırma önizlemeleri için ortak)
 *
 * Neden public/pdf.worker.min.mjs?
 *   CRA/webpack, node_modules'teki pdf.worker.min.mjs'i `new URL(...)` ile
 *   işlerken babel'e sokuyor ve içine /app/node_modules/@babel/runtime/...
 *   gibi tarayıcıda ÇÖZÜLEMEYEN importlar enjekte ediyor → worker sessizce
 *   başlıyor, belge hiç yüklenmiyor. Ayrıca statik sunucular .mjs'i
 *   "application/octet-stream" döndürebiliyor ve dinamik import() bunu reddediyor.
 *   Çözüm: ham (kendine yeterli — import/export içermeyen) worker kaynağı
 *   public/ altından fetch edilir ve blob: URL'i üzerinden MODÜL worker olarak
 *   başlatılır — hem derleme dönüşümünden hem MIME başlığından bağımsız.
 *
 * NOT: public/pdf.worker.min.mjs dosyası pdfjs-dist sürümüne (package.json:
 * "pdfjs-dist": "4.10.38") bağlıdır; pdfjs güncellenirse bu dosya da
 * node_modules/pdfjs-dist/build/pdf.worker.min.mjs'ten yenilenmelidir.
 */
import { getDocument, GlobalWorkerOptions } from "pdfjs-dist";

let workerPortPromise = null;

/** pdf.js worker'ını bir kez hazırlar (sonraki çağrılar aynı örneği döndürür) */
export function getPdfWorkerPort() {
  if (!workerPortPromise) {
    workerPortPromise = (async () => {
      const src = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.mjs`;
      const res = await fetch(src);
      if (!res.ok) throw new Error(`PDF worker kaynağı alınamadı (HTTP ${res.status})`);
      const code = await res.text();
      const blobUrl = URL.createObjectURL(new Blob([code], { type: "text/javascript" }));
      return new Worker(blobUrl, { type: "module" });
    })().catch((e) => {
      workerPortPromise = null;   // sonraki denemelerde tekrar dene
      throw e;
    });
  }
  return workerPortPromise;
}

/** Worker'ı hazırlar ve pdf.js global ayarına yazar */
export async function ensurePdfWorker() {
  const workerPort = await getPdfWorkerPort();
  GlobalWorkerOptions.workerPort = workerPort;
  return workerPort;
}

/**
 * ArrayBuffer / Uint8Array verisinden PDF dokümanı yükler.
 * @returns {Promise<object>} pdf.js PDFDocumentProxy
 *
 * ÖNEMLİ: Worker tüm önizlemeler arasında PAYLAŞILIR. pdf.js'te bir dokümanın
 * destroy() edilmesi ortak worker'ı da yok eder ve sonraki yükleme
 * "PDFWorker.fromPort - the worker is being destroyed" hatasıyla patlar.
 * Bu yüzden dokümanlar destroy EDİLMEZ; yalnızca referans bırakılır.
 */
export async function loadPdfDocument(data) {
  await ensurePdfWorker();
  return getDocument({
    data: data instanceof Uint8Array ? data : new Uint8Array(data),
    isEvalSupported: false,
  }).promise;
}
